<template>
  <v-navigation-drawer width="30%" v-model="localDrawer" right temporary app>
    <v-list-item class="primary">
      <v-list-item-content>
        <v-list-item-title id="drawer-title" class="font-weight-medium white--text">
          Matrículas
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item id="list-item-aluno-header">
      <v-list-item-avatar>
        <v-img id="avatar-aluno-header" :src="aluno.sexo_id === 1 ? masculino : feminino"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title id="aluno-nome-header">
          {{ aluno.nomecompleto ? aluno.nomecompleto : "loading..." }}
        </v-list-item-title>
        <v-list-item-subtitle id="aluno-escola-header">
          {{ verificarEscolas(aluno.ESCOLA) || "- - -" }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list class="px-3" dense>
      <v-list-item-title>
        <p id="aluno-matricula" class="font-weight-light subtitle-1 text-caption">
          <strong>Matricula:</strong> {{ aluno.id ? aluno.id : "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p id="aluno-situacao" class="font-weight-light subtitle-1 text-caption">
          <strong>Situação:</strong> {{ aluno.situacao ? aluno.situacao : "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p id="aluno-turma" class="font-weight-light subtitle-1 text-caption">
          <strong>Turma:</strong> {{ aluno.TURMA ? aluno.TURMA : "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p id="aluno-escola-detalhe" class="font-weight-light subtitle-1 text-caption">
          <strong>Escola: </strong>
          {{ verificarEscolas(aluno.ESCOLA) }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <v-btn :id="`btn-migrar-${aluno.id}`" @click="modal" x-small color="success">Migrar</v-btn>
        <v-tooltip bottom :disabled="podeRemanejar">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :id="`btn-remanejar-${aluno.id}`"
              @click="modalRemanejar"
              x-small
              color="primary"
              class="ml-1"
              :disabled="!podeRemanejar"
              v-bind="attrs"
              v-on="on"
              >Remanejar</v-btn
            >
          </template>
          <span>{{ tooltipRemanejar }}</span>
        </v-tooltip>
        <v-tooltip v-if="!aluno.estaDeletado" color="error" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :id="`btn-deletar-matricula-${aluno.id}`"
              x-small
              class="ml-1"
              color="error"
              v-bind="attrs"
              v-on="on"
              @click="() => deletarMatricula(aluno)"
            >
              <v-icon small>fa fa-trash </v-icon>
            </v-btn>
          </template>
          <span>Apagar matricula</span>
        </v-tooltip>
      </v-list-item-title>
      <v-list-item-title class="mt-4">
        <v-list-item-content>
          <v-divider></v-divider>
        </v-list-item-content>
      </v-list-item-title>
    </v-list>
    <v-list-item-title class="px-3" v-if="matriculas.length > 1">
      <p id="outras-matriculas" class="font-weight-bold h5">
        Outras matrículas relacionadas a esse aluno
      </p>
    </v-list-item-title>

    <v-list
      class="px-3"
      dense
      v-for="matricula in matriculas"
      :key="matricula.id"
      :id="`list-item-detalhe-matricula-${matricula.id}`"
    >
      <v-list-item-title>
        <p :id="`matricula-id-${matricula.id}`" class="font-weight-light subtitle-1 text-caption">
          <strong>Matricula:</strong> {{ matricula.id || "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p
          :id="`matricula-situacao-${matricula.id}`"
          class="font-weight-light subtitle-1 text-caption"
        >
          <strong>Situação:</strong> {{ matricula.situacao || "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p
          :id="`matricula-turma-${matricula.id}`"
          class="font-weight-light subtitle-1 text-caption"
        >
          <strong>Turma:</strong> {{ matricula.turma?.descricao || "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <p
          :id="`matricula-escola-${matricula.id}`"
          class="font-weight-light subtitle-1 text-caption"
        >
          <strong>Escola: </strong>
          {{ matricula.turma?.franquia?.descricao || "- - -" }}
        </p>
      </v-list-item-title>
      <v-list-item-title>
        <v-btn
          :id="`btn-migrar-matricula-${matricula.id}`"
          @click="modal"
          x-small
          color="success"
          :disabled="
            matricula.situacao == 'TRANSFERIDO' ||
            matricula.ano !== String(new Date().getFullYear())
          "
          >Migrar</v-btn
        >
        <v-tooltip v-if="!matricula.estaDeletado" color="error" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :id="`btn-deletar-matricula-${matricula.id}`"
              x-small
              class="ml-1"
              color="error"
              v-bind="attrs"
              v-on="on"
              @click="() => deletarMatricula(matricula)"
            >
              <v-icon small>fa fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Apagar matrícula</span>
        </v-tooltip>
      </v-list-item-title>

      <v-list-item-title class="mt-4">
        <v-list-item-content>
          <v-divider></v-divider>
        </v-list-item-content>
      </v-list-item-title>
    </v-list>

    <e-modal-transferir-matricula
      id="modal-transferir-matricula"
      @dialogChange="dialog = $event"
      :dialog="dialog"
      @changeDialog="modal"
      :matricula="{ ...aluno }"
    ></e-modal-transferir-matricula>
    <e-modal-remanejar-matricula
      id="modal-remanejar-matricula"
      :dialog="dialogRemanejar"
      :matricula="matriculaParaRemanejar"
      @dialogChange="dialogRemanejar = $event"
      @remanejo-concluido="recarregarLista"
    ></e-modal-remanejar-matricula>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    matriculas: {
      type: Array,
      required: true,
    },
    aluno: {
      type: Object,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    localMatriculas() {
      return this.matriculas;
    },
    podeRemanejar() {
      const role = this.user?.role?.name;

      if (!this.$constants.PERMISSAO_PARA_REMANEJAR.includes(role)) {
        return false;
      }

      if (!["CURSANDO", "RECEBIDA"].includes(this.aluno.situacao)) {
        return false;
      }

      return this.aluno.ESCOLA === this.user.configuracao_id;
    },
    tooltipRemanejar() {
      if (!this.$constants.PERMISSAO_PARA_REMANEJAR.includes(this.user?.role?.name)) {
        return "Você não tem permissão para remanejar";
      }
      if (!this.podeRemanejar) {
        return "Você só pode remanejar alunos da sua escola";
      }
      return "Remanejar aluno para outra turma";
    },
  },
  mounted() {
    this.getFranquias();
  },
  data() {
    return {
      localDrawer: this.value,
      dialog: false,
      dialogRemanejar: false,
      matriculaParaRemanejar: null,
      masculino: "https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png",
      feminino:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbUqkRN4QaEzCW4brgWElc7lv8HdwP8RyxJ89WdDWAoIO-rEUIACXkEXG4n2mDGMLuz4Q&usqp=CAU",
      franquias: [],
    };
  },
  methods: {
    async getFranquias() {
      this.franquias = await this.$services.franquiasService.syncAll();
    },
    async modal() {
      this.dialog = !this.dialog;
    },
    async modalRemanejar() {
      const matriculaCompleta = await this.$services.matriculasService.getMatricula(this.aluno.id);
      this.matriculaParaRemanejar = {
        ...this.aluno,
        turma: matriculaCompleta.turma,
        serie_id: matriculaCompleta.serie_id,
        sistema_bncc_id: matriculaCompleta.turma?.sistema_bncc_id,
        sistema_bncc: matriculaCompleta.turma?.sistema_bncc_id,
      };
      this.dialogRemanejar = true;
    },
    async recarregarLista() {
      this.dialogRemanejar = false;
      this.$emit("matricula-deletada");
    },
    verificarEscolas(escola) {
      const franquia = this.franquias.filter((dado) => dado.id === escola);
      return franquia[0]?.descricao;
    },
    async deletarMatricula(matricula) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta matricula?",
        confirmationCode: matricula.id,
        confirmationMessage: `Por favor, digite <strong>${matricula.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Solicitando deleção da Matricula");
              try {
                await this.$services.matriculasService.solicitarDelecaoMatricula(matricula);
                this.$toast.success("Solicitação enviada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
